<lib-chart-line #ChartWrapper disableLegend [chartConf]="conf"/>